import { AboutHR, AboutEN } from '@/assets/images';

export default {
  first: {
    ar:
      'مرحباً بك في جزيرة المرح، وجهتك المثالية للمرح والمكافآت!\n' +
      'العب ألعاباً ممتعة للحصول على فرصة للفوز بأفضل عطلة مع إقامة، وفرصة ربح 9,999 نقطة مكافآت أسبوعياً، والاستفادة من العروض اليومية الجديدة، واستكشاف متجر الفانشوب الحصري!\n',
    en:
      '"Welcome to Golden Getaway — your ultimate destination for fun and rewards!\n' +
      'Play exciting games for a shot at the ultimate staycation, get a chance weekly to win 9.999 Rewards Points, unlock fresh daily deals, and explore our exclusive Fanshop!'
  },

  second: {
    ar: 'الحملة مستمرة من 12 مايو إلى 15 يونيو.',
    en: 'The campaign will last from May 12th - June 15th.'
  },

  third: {
    ar: 'سيتم التواصل مع الفائزين مباشرة عبر البريد الإلكتروني.',
    en: 'Winners wil be contacted directly via email.'
  },

  image: {
    hr: AboutHR,
    en: AboutEN
  }
};
